import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CheckboxComponent } from "@shared/controls/checkbox/checkbox.component";
import { CellDataType } from '@models/grid/cell-data-type.enum';
import { ColDefCommunityExtended, DateRange, GroupByOption, NumberRange } from "@models/grid/grid-filter";
import {
  DateRangePickerComponent
} from "@shared/controls/date-range-picker/date-range-picker.component";
import { DividerComponent } from "@shared/components/commons/divider/divider.component";
import {
  NumberRangeInputComponent
} from "@shared/controls/number-range-input/number-range-input.component";
import { SearchInputComponent } from "@shared/controls/search-input/search-input.component";


@Component({
  selector: 'app-search-filter-list',
  standalone: true,
  imports: [
    CheckboxComponent,
    DateRangePickerComponent,
    DividerComponent,
    NumberRangeInputComponent,
    ReactiveFormsModule,
    SearchInputComponent,
    FormsModule
  ],
  templateUrl: './search-filter-list.component.html',
  styleUrl: './search-filter-list.component.scss'
})
export class SearchFilterListComponent {
  @Input() column!: ColDefCommunityExtended;
  @Input() groupByOptions: GroupByOption[] = [];
  @Output() dateRangeSelected = new EventEmitter<DateRange>();
  @Output() numberRangeSelected = new EventEmitter<NumberRange>();
  @Output() filterOptionChange = new EventEmitter<{indexOption: number, active: boolean}>();
  @Output() filterSearch = new EventEmitter<string>();
  @Output() searchByOption = new EventEmitter<string>();

  searchText = '';

  onDateRangeSelected($event: DateRange): void {
    this.dateRangeSelected.emit($event);
  }

  onNumberRangeSelected($event: NumberRange): void {
    this.numberRangeSelected.emit($event)
  }

  onFilterOptionChange(indexOption: number, active: boolean): void {
    this.filterOptionChange.emit({ indexOption, active })
  }

  onSearchFilter(searchText: string): void {
    this.filterSearch.emit(searchText);
  }

  onSearch(searchText: string): void {
    this.searchByOption.emit(searchText);
  }

  protected readonly CellDataType = CellDataType;
}
